import { RiskBadge, CAT_COLOR, LEVEL_SQUARE } from "./RiskBadge";

function sevColor(v) {
  return v >= 45 ? "#E24B4A" : v >= 25 ? "#BA7517" : "#1D9E75";
}

function Bar({ pct, color, label }) {
  return (
    <div>
      <div className="h-1 w-full rounded-full bg-neutral-100">
        <div className="h-1 rounded-full" style={{ width: `${Math.min(100, Math.max(6, pct))}%`, backgroundColor: color }} />
      </div>
      <span className="mt-1 block text-[11px] text-neutral-400">{label}</span>
    </div>
  );
}

export default function SectorAverages({ sectors }) {
  return (
    <div className="rounded-lg border border-[#e8e6df] bg-white p-6 md:p-8">
      <h3 className="font-heading text-xl font-semibold mb-5">Sector averages — all five dimensions</h3>
      <div className="space-y-6">
        {sectors.map((s) => (
          <div key={s.sector} data-testid={`sector-${s.sector.replace(/[^a-zA-Z]+/g, "-")}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="font-medium text-[#1a1a18]">{s.sector}</span>
              <RiskBadge level={s.composite_level} />
            </div>
            <div className="grid grid-cols-5 gap-3">
              <Bar pct={s.cust} color={sevColor(s.cust)} label={`Cust ${s.cust}%`} />
              <Bar pct={s.geo} color={sevColor(s.geo)} label={`Geo ${s.geo}%`} />
              <Bar pct={s.supplier_level === "high" ? 70 : s.supplier_level === "medium" ? 40 : 15} color={LEVEL_SQUARE[s.supplier_level]} label={`Supp ${s.supplier_level}`} />
              <Bar pct={s.prod} color={sevColor(s.prod)} label={`Prod ${s.prod}%`} />
              <Bar pct={s.credit_level === "high" ? 70 : s.credit_level === "medium" ? 40 : 15} color={LEVEL_SQUARE[s.credit_level]} label={`Credit ${s.credit_level}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
